// extracted by mini-css-extract-plugin
module.exports = {"card":"payment-funnel_card__Dh65Z","section":"payment-funnel_section__8qutE","anchor":"payment-funnel_anchor__PBR2H"};